export const COMMON_MODAL_CLOSE = 'COMMON_MODAL_CLOSE'
export const COMMON_MODAL_OPEN = 'COMMON_MODAL_OPEN'
export const COMMON_ALERT_OPEN = 'COMMON_ALERT_OPEN'
export const COMMON_ALERT_CLOSE = 'COMMON_ALERT_CLOSE'
export const COMMON_NOTIFICATION_CLOSE = 'COMMON_NOTIFICATION_CLOSE'
export const COMMON_NOTIFICATION_OPEN = 'COMMON_NOTIFICATION_OPEN'
export const COMMON_EMAIL_NOTIFICATION_POST = 'COMMON_EMAIL_NOTIFICATION_POST'
export const COMMON_EMAIL_NOTIFICATION_DISMISS = 'COMMON_EMAIL_NOTIFICATION_DISMISS'
export const COMMON_EMAIL_NOTIFICATION_SUCCESS = 'COMMON_EMAIL_NOTIFICATION_SUCCESS'
export const COMMON_EMAIL_NOTIFICATION_FAIL = 'COMMON_EMAIL_NOTIFICATION_FAIL'
export const COMMON_GET_WP_CONTENT_ATTEMPT = 'COMMON_GET_WP_CONTENT_ATTEMPT'
export const COMMON_GET_WP_CONTENT_SUCCESS = 'COMMON_GET_WP_CONTENT_SUCCESS'
export const COMMON_GET_WP_CONTENT_FAILURE = 'COMMON_GET_WP_CONTENT_FAILURE'
export const COMMON_SCROLL_TO_ELEMENT = 'COMMON_SCROLL_TO_ELEMENT'
export const COMMON_GET_FILE = 'COMMON_GET_FILE'
export const COMMON_EXPORT_CSV = 'COMMON_EXPORT_CSV'
export const COMMON_EXPORT_POSTINGS_UPDATES_CSV = 'COMMON_EXPORT_POSTINGS_UPDATES_CSV'

export default {
  COMMON_MODAL_CLOSE,
  COMMON_MODAL_OPEN,
  COMMON_ALERT_OPEN,
  COMMON_ALERT_CLOSE,
  COMMON_NOTIFICATION_CLOSE,
  COMMON_NOTIFICATION_OPEN,
  COMMON_EMAIL_NOTIFICATION_POST,
  COMMON_EMAIL_NOTIFICATION_DISMISS,
  COMMON_EMAIL_NOTIFICATION_SUCCESS,
  COMMON_EMAIL_NOTIFICATION_FAIL,
  COMMON_GET_WP_CONTENT_ATTEMPT,
  COMMON_GET_WP_CONTENT_SUCCESS,
  COMMON_GET_WP_CONTENT_FAILURE,
  COMMON_SCROLL_TO_ELEMENT,
  COMMON_GET_FILE,
  COMMON_EXPORT_CSV,
  COMMON_EXPORT_POSTINGS_UPDATES_CSV
}
